import { createRouter, createWebHashHistory, createWebHistory } from "vue-router";


import Home from '../components/Home.vue'
import Evaluation from '../components/Evaluation.vue'
import News from '../components/News.vue'
import About from '../components/About.vue'
import Appreciation from '../components/Appreciation.vue'
import Contact from '../components/Contact.vue'
import Reting from '../components/Reting.vue'
import Agent from '../components/Agent.vue'
import Standard from '../components/Standard.vue'
import Charge from '../components/Charge.vue'

const routes = [

    {
        path: '/',
        name: 'Home',
        component: Home
        //懒加载方式,上面的路径可以不需要引入
        //component: ()=>import(/* webpackChunkName: "Home" */ '../components/Home.vue')
    },
    {
        path: '/Evaluation',
        name: 'Evaluation',
        component: Evaluation,
        //懒加载方式,上面的路径可以不需要引入
        //component: ()=>import(/* webpackChunkName: "Evaluation" */ '../components/Evaluation.vue')
    },
    {
        path: '/News/:id',
		name: 'News',
        component: News,
        //懒加载方式,上面的路径可以不需要引入
        //component: ()=>import(/* webpackChunkName: "News" */ '../components/News.vue')
    },
    {
        path: '/About',
        name: 'About',
        component: About,
        //懒加载方式,上面的路径可以不需要引入
        //component: ()=>import(/* webpackChunkName: "About" */ '../components/About.vue')
    },
    {
        path: '/Contact',
        name: 'Contact',
        component: Contact,
        //懒加载方式,上面的路径可以不需要引入
        //component: ()=>import(/* webpackChunkName: "Contact" */ '../components/Contact.vue')
        
    },
    {
        path: '/Appreciation',
        name: 'Appreciation',
        component: Appreciation,
        //懒加载方式,上面的路径可以不需要引入
        //component: ()=>import(/* webpackChunkName: "Appreciation" */ '../components/Appreciation.vue')
    },
    {
        path: '/Reting/:name',
        name: 'Reting',
        component: Reting,
        //懒加载方式,上面的路径可以不需要引入
        //component: ()=>import(/* webpackChunkName: "Appreciation" */ '../components/Appreciation.vue')
    },
    {
        path: '/Agent',
        name: 'Agent',
        component: Agent,
    },
    {
        path: '/Standard',
        name: 'Standard',
        component: Standard,
    },
    {
        path: '/Charge',
        name: 'Charge',
        component: Charge,
    }
]


const router = createRouter({
    history: createWebHistory(process.env.BASE_URL), //process.env.BASE_URL
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    next()
})

//曝光出去
export default router
